import { LaravelResponse, PagedSingleSelectField, laravelSelectFetchConfig } from "@dgs/core";
import axios, { AxiosRequestConfig } from "axios";
import { FC } from "react";
import { AirportIndexResource } from "./types/airport";

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
	clearable?: boolean;
	required?: boolean;
}

const getLabel = (airport: AirportIndexResource) => {
	if (airport.name) {
		return `${airport.name} | ${airport.city} | ${airport.countryName} | ${airport.iataCode}`;
	}
	return "";
};

const airportFetcher = (AxiosRequestConfig?: AxiosRequestConfig) =>
	axios.get<LaravelResponse<AirportIndexResource[]>>(`airports`, AxiosRequestConfig);

export const AirportSingleSelectField: FC<Props> = ({ name, label, disabled, clearable = true, required = false }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			disabled={disabled}
			fetchConfig={laravelSelectFetchConfig(["airports"], (search, page) =>
				airportFetcher({ params: { search, page } }).then((r) => r.data),
			)}
			clearable={clearable}
			required={required}
			getLabel={getLabel}
		/>
	);
};
